import React, { useState, useEffect } from 'react';

const API = '/api';

interface Recipient { id: number; phone_number: string; name: string; active: boolean; }
interface NotifConfig {
  id?: number; phone_number: string; name: string; active: boolean;
  send_daily_report: boolean; send_hora: string;
  include_flujo: boolean; include_ventas: boolean; include_conversion: boolean;
  include_sin_empleado: boolean; include_clientes_sin_atender: boolean;
}

export default function WhatsAppPanel({ token }: { token: string }) {
  const [recipients, setRecipients] = useState<Recipient[]>([]);
  const [configs, setConfigs] = useState<NotifConfig[]>([]);
  const [newPhone, setNewPhone] = useState('');
  const [newName, setNewName] = useState('');
  const [testMsg, setTestMsg] = useState('');
  const [status, setStatus] = useState('');
  const [activeTab, setActiveTab] = useState<'test'|'reportes'>('test');

  const load = () => {
    fetch(`${API}/whatsapp/recipients`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(setRecipients);
    fetch(`${API}/notif/config`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(setConfigs);
  };

  useEffect(() => { load(); }, []);

  const addRecipient = async () => {
    if (!newPhone) return;
    await fetch(`${API}/whatsapp/recipients`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ phone_number: newPhone, name: newName })
    });
    setNewPhone(''); setNewName(''); load();
  };

  const deleteRecipient = async (id: number) => {
    await fetch(`${API}/whatsapp/recipients/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
    load();
  };

  const sendTest = async () => {
    setStatus('Enviando...');
    const resp = await fetch(`${API}/whatsapp/test`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ message: testMsg || 'Test PeopleCount OK' })
    });
    const data = await resp.json();
    setStatus(data.success ? '✅ Enviado' : '❌ Error: ' + JSON.stringify(data));
  };

  const saveConfig = async (cfg: NotifConfig) => {
    const resp = await fetch(`${API}/notif/config`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(cfg)
    });
    const data = await resp.json();
    setStatus(data.success ? '✅ Config guardada' : '❌ ' + JSON.stringify(data));
    load();
  };

  const deleteConfig = async (id: number) => {
    await fetch(`${API}/notif/config/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
    load();
  };

  const sendReportNow = async (cfg: NotifConfig) => {
    setStatus('Enviando reporte...');
    const resp = await fetch(`${API}/notif/send-report`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ phone_number: cfg.phone_number, config: cfg })
    });
    const data = await resp.json();
    setStatus(data.success ? '✅ Reporte enviado' : '❌ ' + JSON.stringify(data));
  };

  const addNewConfig = () => {
    if (!newPhone) return;
    const cfg: NotifConfig = {
      phone_number: newPhone, name: newName, active: true,
      send_daily_report: true, send_hora: '08:00',
      include_flujo: true, include_ventas: true, include_conversion: true,
      include_sin_empleado: true, include_clientes_sin_atender: true
    };
    saveConfig(cfg);
    setNewPhone(''); setNewName('');
  };

  return (
    <div style={{ padding: '24px' }}>
      <h2 style={{ color: '#fff', marginBottom: '24px' }}>📱 WhatsApp</h2>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '24px' }}>
        {(['test','reportes'] as const).map(t => (
          <button key={t} onClick={() => setActiveTab(t)} style={{
            padding: '8px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer',
            background: activeTab === t ? '#3b82f6' : '#1e293b',
            color: '#fff', fontWeight: activeTab === t ? 700 : 400
          }}>{t === 'test' ? '🔔 Destinatarios & Test' : '📊 Reportes Diarios'}</button>
        ))}
      </div>

      {status && <div style={{ background: '#1e293b', color: '#94a3b8', padding: '10px 16px', borderRadius: '8px', marginBottom: '16px' }}>{status}</div>}

      {activeTab === 'test' && (
        <div>
          {/* Destinatarios */}
          <div style={{ background: '#1e293b', borderRadius: '12px', padding: '20px', marginBottom: '20px' }}>
            <h3 style={{ color: '#fff', marginBottom: '16px' }}>Destinatarios</h3>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
              <input value={newPhone} onChange={e => setNewPhone(e.target.value)} placeholder="Número (ej: 5492645678350)"
                style={{ flex: 2, padding: '8px 12px', borderRadius: '6px', border: '1px solid #334155', background: '#0f172a', color: '#fff' }} />
              <input value={newName} onChange={e => setNewName(e.target.value)} placeholder="Nombre"
                style={{ flex: 1, padding: '8px 12px', borderRadius: '6px', border: '1px solid #334155', background: '#0f172a', color: '#fff' }} />
              <button onClick={addRecipient} style={{ padding: '8px 16px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>+ Agregar</button>
            </div>
            {recipients.map(r => (
              <div key={r.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px', background: '#0f172a', borderRadius: '8px', marginBottom: '8px' }}>
                <span style={{ color: '#fff' }}>📞 {r.name} — {r.phone_number}</span>
                <span style={{ color: r.active ? '#22c55e' : '#ef4444', marginRight: '12px' }}>{r.active ? '✅ Activo' : '⛔ Inactivo'}</span>
                <button onClick={() => deleteRecipient(r.id)} style={{ background: '#ef4444', color: '#fff', border: 'none', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer' }}>✕</button>
              </div>
            ))}
          </div>

          {/* Test */}
          <div style={{ background: '#1e293b', borderRadius: '12px', padding: '20px' }}>
            <h3 style={{ color: '#fff', marginBottom: '16px' }}>Enviar mensaje de prueba</h3>
            <div style={{ display: 'flex', gap: '8px' }}>
              <input value={testMsg} onChange={e => setTestMsg(e.target.value)} placeholder="Mensaje (opcional)"
                style={{ flex: 1, padding: '8px 12px', borderRadius: '6px', border: '1px solid #334155', background: '#0f172a', color: '#fff' }} />
              <button onClick={sendTest} style={{ padding: '8px 20px', background: '#22c55e', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>Enviar test</button>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'reportes' && (
        <div>
          {/* Agregar nuevo destinatario de reporte */}
          <div style={{ background: '#1e293b', borderRadius: '12px', padding: '20px', marginBottom: '20px' }}>
            <h3 style={{ color: '#fff', marginBottom: '16px' }}>➕ Agregar destinatario de reporte</h3>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <input value={newPhone} onChange={e => setNewPhone(e.target.value)} placeholder="Número (ej: 5492645678350)"
                style={{ flex: 2, padding: '8px 12px', borderRadius: '6px', border: '1px solid #334155', background: '#0f172a', color: '#fff' }} />
              <input value={newName} onChange={e => setNewName(e.target.value)} placeholder="Nombre"
                style={{ flex: 1, padding: '8px 12px', borderRadius: '6px', border: '1px solid #334155', background: '#0f172a', color: '#fff' }} />
              <button onClick={addNewConfig} style={{ padding: '8px 16px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>+ Agregar</button>
            </div>
          </div>

          {/* Configs */}
          {configs.map((cfg, idx) => (
            <div key={cfg.id || idx} style={{ background: '#1e293b', borderRadius: '12px', padding: '20px', marginBottom: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <div>
                  <span style={{ color: '#fff', fontWeight: 700, fontSize: '16px' }}>📞 {cfg.name}</span>
                  <span style={{ color: '#64748b', marginLeft: '10px' }}>{cfg.phone_number}</span>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={() => sendReportNow(cfg)} style={{ padding: '6px 14px', background: '#f59e0b', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>▶ Enviar ahora</button>
                  {cfg.id && <button onClick={() => deleteConfig(cfg.id!)} style={{ padding: '6px 14px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>✕</button>}
                </div>
              </div>

              {/* Hora envío */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
                <span style={{ color: '#94a3b8' }}>⏰ Hora de envío:</span>
                <input type="time" value={cfg.send_hora} onChange={e => {
                  const nc = { ...cfg, send_hora: e.target.value };
                  setConfigs(configs.map((c, i) => i === idx ? nc : c));
                }} style={{ padding: '4px 8px', borderRadius: '6px', border: '1px solid #334155', background: '#0f172a', color: '#fff' }} />
                <label style={{ color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <input type="checkbox" checked={cfg.active} onChange={e => setConfigs(configs.map((c, i) => i === idx ? { ...c, active: e.target.checked } : c))} />
                  Activo
                </label>
              </div>

              {/* Checks de contenido */}
              <div style={{ color: '#94a3b8', marginBottom: '10px', fontWeight: 600 }}>📋 Incluir en el reporte:</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '16px' }}>
                {[
                  { key: 'include_flujo', label: '👥 Flujo de personas' },
                  { key: 'include_ventas', label: '💰 Ventas del día' },
                  { key: 'include_conversion', label: '📈 Tasa de conversión' },
                  { key: 'include_sin_empleado', label: '⚠️ Alertas sin empleado' },
                  { key: 'include_clientes_sin_atender', label: '🚨 Clientes sin atender' },
                ].map(({ key, label }) => (
                  <label key={key} style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#e2e8f0', cursor: 'pointer',
                    background: '#0f172a', padding: '10px 14px', borderRadius: '8px',
                    border: `1px solid ${(cfg as any)[key] ? '#3b82f6' : '#334155'}` }}>
                    <input type="checkbox" checked={(cfg as any)[key]} onChange={e => {
                      const nc = { ...cfg, [key]: e.target.checked };
                      setConfigs(configs.map((c, i) => i === idx ? nc : c));
                    }} />
                    {label}
                  </label>
                ))}
              </div>

              <button onClick={() => saveConfig(cfg)} style={{ padding: '8px 20px', background: '#22c55e', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600 }}>
                💾 Guardar configuración
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
